<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->


<div class="ibox login-content">
  <div class="text-center">
    <span class="auth-head-icon"><em class="la la-life-saver"></em></span>
  </div>

  <div class="ibox-head justify-content-center">
    <div class="ibox-title text-uppercase text-center" i18n="@@needHelp">Need help?</div>
  </div>

  <div class="ibox-body">
    <!--    <div class="row">-->
    <!--      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4">-->
    <!--        <h4 class="heading" i18n="@@helpMakeRemovalRequest">Make a removal request.</h4>-->
    <!--        <br/>-->
    <!--        <div class="embed-responsive embed-responsive-16by9">-->
    <!--          <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/LH0xS-qy9uM?rel=0"-->
    <!--                  allowfullscreen></iframe>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4">-->
    <!--        <h4 i18n="@@helpPrintVouchers">Print your pickup vouchers</h4>-->
    <!--        <br/>-->
    <!--        <div class="embed-responsive embed-responsive-16by9">-->
    <!--          <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/yGe-X5gUjhI?rel=0"-->
    <!--                  allowfullscreen></iframe>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
        <app-display-logos-available [oneLine]="true"></app-display-logos-available>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">
            <h4 i18n="@@helpUpdateBrowser">Update your browser</h4>
            <br/>
            <p i18n="@@helpUpdateBrowserInfo">
              If you have any error, update browser.<br>Or replace by firefox or chrome.
            </p>
            <br/>
            <app-display-logos-browsers [oneLine]="true"></app-display-logos-browsers>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">
            <h4>Adobe Reader</h4>
            <br/>
            <p i18n="@@helpReadVoucher">To read and print your voucher.</p>
            <a href="https://get.adobe.com/fr/reader/" rel="noopener" target="_blank">
              <img class="img-fluid" src="../../../assets/img/adobe.jpeg" alt="Acrobat Reader" style="max-width: 100%;">
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">
            <h4 i18n="@@helpRemoteControlSoftware">Remote control software</h4>
            <br/>
            <a href="https://www.teamviewer.com/fr/" rel="noopener" target="_blank">
              <img class="img-fluid" src="../../../assets/img/teamviewer.png" alt="Teamviewer"
                   style="height: 55px; max-width: 100%;">
            </a>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">
            <h4 i18n="@@itSupport">IT support</h4>
            <br/>
            <p i18n="@@itSupportInfo">Computer technical problems only (Call and free service).</p>
            <a href="tel:+33485800240"><strong>04 85 80 02 40</strong></a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-display-go-home></app-display-go-home>
      </div>
    </div>
  </div>
</div>








